import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { addQueryParams } from 'utils/url';

export default class EnforceAutologinParametersRemoved extends PureComponent {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
    }),
    router: PropTypes.shape({
      replace: PropTypes.func,
      createLocation: PropTypes.func,
    }),
  };

  componentDidMount() {
    const { location, router } = this.props;
    if (!location || !router) {
      return;
    }

    if (!get(location, 'query.ssoToken') || !get(location, 'query.customerNum')) {
      return;
    }

    const { ssoToken, customerNum, ...newQuery } = location.query;

    const newLocation = addQueryParams(location.pathname, newQuery);
    router.replace(router.createLocation(newLocation));
  }

  render() {
    return null; // no visual representation
  }
}
